<template>
  <div>
    <div class="bg-blue-900 p-4 lg:p-12">
      <div class="max-w-5xl mx-auto mb-12">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between">
          <h4 class="text-white font-bold">Users</h4>

          <RouterLink
            :to="{ name: 'admin.users.create' }"
            class="btn btn-brand style-inverted px-6"
          >
            New user
          </RouterLink>
        </div>
      </div>
    </div>
    <div class="px-4 pb-4 lg:px-12 lg:pb-12 -mt-12">
      <div class="max-w-5xl mx-auto">
        <UserListComponent />
      </div>
    </div>
  </div>
</template>

<script>
import UserListComponent from '@/components/Users/List.vue';

export default {
  name: 'UserList',
  components: {
    UserListComponent,
  },
};
</script>
